import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchTiersList() {
      return axiosIns.get('/tiers')
    },
    createNewTier(_, payload) {
      return axiosIns.post('/tiers', payload)
    },
    updateTier(_, { data, tierId }) {
      return axiosIns.patch(`tiers/${tierId}`, data)
    },
    getOneTier(_, tierId) {
      return axiosIns.get(`tiers/${tierId}`)
    },
    deleteTier(_, tierId) {
      return axiosIns.delete(`tiers/${tierId}`)
    },
    getSubscriptionTierByWalletId(_, walletId) {
      return axiosIns.get(`/subscriptions/wallet/${walletId}`)
    },
  },
}
